import { render, staticRenderFns } from "./VComplianceLogbook.vue?vue&type=template&id=5734eeb3"
import script from "./VComplianceLogbook.vue?vue&type=script&lang=js"
export * from "./VComplianceLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports